import { render, staticRenderFns } from "./incentiveOt.vue?vue&type=template&id=63680567"
import script from "./incentiveOt.vue?vue&type=script&lang=js"
export * from "./incentiveOt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports